<template>
    <Modal
        id="connect-nyala-project-modal"
        ref="connect-nyala-project-modal"
        v-model:open="open"
        title="connect_nyala_project"
        width="xl"
        @submit="submit"
        @cancel="cancel"
    >
        <TextField
            v-model="emptyNyalaProject.external_tokenized_asset_id"
            label="nyala_project_external_tokenized_asset_id"
            name="external_tokenized_asset_id"
            :required="true"
            help="help_nyala_project_external_tokenized_asset_id"
        />

        <TextField
            v-model="emptyNyalaProject.external_project_id"
            label="nyala_project_external_project_id"
            name="external_project_id"
            :required="true"
            help="help_nyala_project_external_project_id"
        />

        <TextField
            v-model="emptyNyalaProject.unit_name"
            label="nyala_project_unit_name"
            name="unit_name"
            :required="true"
            help="help_nyala_project_unit_name"
        />

        <TextField
            v-model="emptyNyalaProject.integration_passphrase"
            label="nyala_project_integration_passphrase"
            name="integration_passphrase"
            :required="true"
            help="help_nyala_project_integration_passphrase"
        />

        <SelectField
            v-model="emptyNyalaProject.custody_provider"
            :options="mapEnumToArray(NyalaCustodyProvider)"
            :reduce="reduceEnumValue"
            label="nyala_project_custody_provider"
            name="custody_provider"
            help="help_nyala_project_custody_provider"
            :required="true"
        />

        <template #actions>
            <MultiActionButton />
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { useEnum, useMultiActionButton } from '@composables/common'
import { Modal, SelectField, TextField } from '@src/components'
import { NyalaProject } from '@src/types'
import { useVModels } from '@vueuse/core'
import { computed } from 'vue'
import { NyalaCustodyProvider } from '@enums/Nyala'

const { mapEnumToArray, reduceEnumValue } = useEnum()

const props = defineProps<{
    open: boolean
    nyalaProject: NyalaProject | null
    disabledFields?: string[] | null
}>()

const emptyNyalaProject = computed(
    () => props.nyalaProject ?? new NyalaProject()
)

const emit = defineEmits(['update:open', 'cancel', 'submit'])

const { open, nyalaProject } = useVModels(props, emit)

const { MultiActionButton } = useMultiActionButton({
    id: 'connect-nyala-project-button',
    actions: [
        {
            label: 'save',
            action: submit,
            disabled: () => disableCreate.value,
        },
    ],
})

function cancel() {
    emit('cancel')
}

function submit() {
    emit('submit')
}

const disableCreate = computed(() => {
    return (
        !nyalaProject.value?.external_project_id ||
        !nyalaProject.value?.external_tokenized_asset_id ||
        !nyalaProject.value?.unit_name ||
        !nyalaProject.value?.integration_passphrase
    )
})
</script>
